/** 登录/注册弹窗（→ 全局挂载，顶栏等多入口共用） */
export const useAuthNav = () => {
  const open = useState('auth-drawer-open', () => false)

  const openLogin = () => {
    open.value = true
  }

  const closeLogin = () => {
    open.value = false
  }

  return { open, openLogin, closeLogin }
}
